import React, { useState } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { UNIFIED_BASE_URL } from "../../webbase";
import { toast } from "react-toastify";

const KYCUpdateModal = ({ show, onHide, emailAddress, onUpdate }) => {
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const [token] = useState(cookie.load("token"));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!status) {
            toast.error("Please select a status");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                `${UNIFIED_BASE_URL}/onboarding/merchant-kyc-status`,
                {
                    emailAddress: emailAddress,
                    status: status.toLowerCase(),
                },
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status === "2000") {
                toast.success(`Successfully ${status.toLowerCase()} KYC request`);
                window.location.reload();
            } else {
                toast.error(response.data.description || "Failed to update KYC status");
            }
        } catch (error) {
            console.error("Error updating KYC status:", error);
            toast.error("Error updating KYC status");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="modal fade"
            id="kycUpdateModal"
            tabIndex="-1"
            aria-labelledby="kycUpdateModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="kycUpdateModalLabel">
                            Update KYC Status
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={emailAddress}
                                    disabled
                                    readOnly
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Status</label>
                                <select
                                    className="form-select"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    required
                                >
                                    <option value="">Select Status</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Updating...
                                        </>
                                    ) : (
                                        "Update Status"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KYCUpdateModal; 